import builder from '../builder';
import CheckBadge from '../../streamline-icons/light/check-badge.svg';

export default builder('IconCheckBadgeLight', CheckBadge);
